import { Stack, Typography } from "@mui/material"

export function RateCardTradeHeader({ currencySymbol }) {
    return (
        <Stack
            direction="row"
            justifyContent="space-between"
            sx={{ py: 1, bgcolor: "background.neutral", px: 1, borderRadius: 0.5 }}
        >
            <Typography variant="caption" color="text.secondary" fontWeight={600}>
                Trade
            </Typography>
            <Typography variant="caption" color="text.secondary" fontWeight={600}>
                Rate ({currencySymbol})
            </Typography>
        </Stack>
    )
}
